import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressListDialogMHComponent } from './address-list-dialog.component';
import { AddressDetailComponent } from 'projects/shared/lib/components/shared/address/detail/address-detail.component';
import { FormsModule } from '@angular/forms';
import { DeliveryReminderModule } from '../../delivery-reminder/delivery-reminder.module';
import { AddressListDialogComponent } from 'projects/shared/lib/components/shared/address/list-dialog/address-list-dialog.component';


@NgModule({
  declarations: [
    AddressListDialogMHComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DeliveryReminderModule,
    AddressDetailComponent,
    AddressListDialogComponent,
  ]
})
export class AddressListDialogModule { }
